import React, { useEffect, useRef } from 'react'

import dayjs from 'dayjs'

import { BiCalendarHeart as CalIcon } from '@react-icons/all-files/bi/BiCalendarHeart'
import { google, outlook, office365, yahoo, ics } from "calendar-link";

const DateToCalendar = (props) => {
  const {
    start_date,
    end_date,
    name,
    description,
    address,
    buttonType = 'icon',
    iconOnly = false,
    showEndDate = true,
    showTimeOnNewLine = false,
    timezone = 'America/Los_Angeles'
  } = props

  const wrapperRef = useRef(null);
  const [open, setOpen] = React.useState(false);

  let start = null
  let end = null

  if (start_date) start = dayjs(start_date)
  if (end_date) end = dayjs(end_date)

  // No diff between start and end date
  // Default time diff is 3 hours
  const dayDiff = dayjs(start_date).diff(dayjs(end_date), 'day')
  const timeDiff = dayjs(start_date).diff(dayjs(end_date), 'hour')
  const showEndTime = showEndDate && timeDiff != -3 && timeDiff != 0 && showEndDate && end.hour() !== 0

  // TODO: on backend, If time is empty or midnight, set to null
  const has_time = start && start.hour() !== 0
  const startDayPretty = start && start.format('ddd. MMM D') || ''
  const startTimePretty = start && has_time ? (start.minute() === 0 ? start.format('ha') : start.format('h:mma')) : '';
  const endDayPretty = end && end.format('ddd. MMM D') || ''
  const endTimePretty = end && end.hour() !== 0
    ? (end.minute() === 0
      ? end.format('h a')
      : end.format('h:mm a'))
    : null;


  const timeRange = start && end && showEndDate && showEndTime
    ? `${startTimePretty} ${endTimePretty ? 'to ' + endTimePretty : ''}`
    : `${startTimePretty}`

  const dateFormated = dayDiff == 0
    ? startDayPretty
    : `${startDayPretty} to ${endDayPretty}`

  const event = {
    title: name,
    details: description,
    location: address,
    startTime: start ? start.format('YYYY-MM-DDTHH:mm:ss') : null,
    endTime: end ? end.format('YYYY-MM-DDTHH:mm:ss') : null
  }

  const gCal = google(event)
  const iCal = ics(event)
  const outlookCal = outlook(event)

  const handleClick = (event) => {
    setOpen(!open);
  }

  const handleOutsideClick = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      //alert("You clicked outside of me!");
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick)
  }, [wrapperRef]);


  const handleClose = () => {
    setOpen(!open);
  }

  const linkMenu = (
    <div className='menu'>
      <h5>Save to cal</h5>
      <a href={gCal} target='_blank'>Google event</a>
      <a href={iCal} target='_blank'>iCal event</a>
      <a href={outlookCal} target='_blank'>Outlook Calendar</a>
    </div>
  )

  return (
    <div
      className='dateToCalendar'
      ref={wrapperRef}
      style={{
        position: 'relative'
      }}>
      {!iconOnly &&
        <span style={{ fontSize: '1.6rem' }}>
          {dateFormated} {showTimeOnNewLine ? `<br />` : '  -  '} {timeRange}
        </span>
      }

      <a
        variant="contained"
        onClick={handleClick}
        style={{
          cursor: 'pointer',
          display: 'inline-block',
          marginLeft: '1rem',
        }}>
          {buttonType == 'icon'
            ? <button className='button ui secondary basic'>
                <CalIcon size='1.6em' sx={{ color: '#666666'}} />
              </button>
            : null
          }
          {iconOnly === false
            ? <span>Save to cal</span>
            : null
          }
      </a>

      <div
        className='popover shadow'
        style={{
          backgroundColor: 'white',
          display: open ? 'inline-block' : 'none',
          fontSize: '1.2rem',
          padding: '1rem',
          position: 'absolute',
          zIndex: 1000000
        }}>
        {linkMenu}
      </div>
      {/*
      <Popover
        id={id}
        //elevation={100000000}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}>
        {linkMenu}
      </Popover>
      */}

    </div>
  )
}

export default DateToCalendar